import { Info } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageProvider";

/** Honest scope for existing previews; this does not add persistence. */
export default function PreviewNotice({ kind = "demo" }: { kind?: "demo" | "session" }) {
  const { t } = useLanguage();
  return (
    <aside className="relative mb-5 flex gap-3 rounded-2xl border border-primary/20 bg-card p-4">
      <Info aria-hidden="true" size={18} className="mt-0.5 shrink-0 text-primary" />
      <div>
        <p className="text-sm font-semibold text-foreground">{t(`ux.preview.${kind}.title`)}</p>
        <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{t(`ux.preview.${kind}.body`)}</p>
      </div>
    </aside>
  );
}
